import React from 'react';
import PropTypes from 'prop-types';

export default class CtaButton extends React.PureComponent {
    static propTypes = {
        cta: PropTypes.object,
        toggleNav: PropTypes.func,
        mobileLocaleActive: PropTypes.bool,
        mobileUserActive: PropTypes.bool
    };

    static contextTypes = {
        globalLinkOnClick: PropTypes.func
    };

    onClick = (e) => {
        const cta = this.props.cta || {};
        const href = cta.href || '#';
        let globalReturnValue = null;
        if (this.context.globalLinkOnClick && typeof this.context.globalLinkOnClick === 'function') {
            globalReturnValue = this.context.globalLinkOnClick(e, href);
        }

        if (globalReturnValue !== false) {
            if (cta && cta.onClick && typeof cta.onClick === 'function') {
                cta.onClick(e);
            }
        }
        this.props.toggleNav();
    };

    render() {
        const config = this.props.cta || {};
        const mobileSubMenuActive = this.props.mobileLocaleActive || this.props.mobileUserActive;
        const label = config.title || '';
        const node = config.node;
        const href = config.href || '#';
        const customClass = config.customClass || '';
        if (!node && !label) {
            console.warn('[EGH] no cta title was provided. The component will not be rendered');
            return (<div />);
        }

        return (
            <div className={`cta accent-bg-color accent-bg-color-hover ${mobileSubMenuActive ? 'hidden' : ''} ${customClass}`} id="cta">
                <a href={href} onClick={this.onClick} className="accent-bg-color accent-bg-color-hover" title={label}>
                    <span className="accent-text-color accent-text-color-hover">
                        {node || label}
                    </span>
                </a>
            </div>
        );
    }
}
